import { render, staticRenderFns } from "./mdropdown.vue?vue&type=template&id=503acdd2&"
import script from "./mdropdown.vue?vue&type=script&setup=true&lang=js&"
export * from "./mdropdown.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./mdropdown.vue?vue&type=style&index=0&id=503acdd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports